import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { fetchVPOSSettings, upsertVPOSSettings } from "../../../api/requests/company-requests";

export const usePaymentSettings = (companyId, companyCode) => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            merchantId: "",
            merchantKey: "",
            merchantSalt: "",
            testMode: false,
            companyId: companyId || "",
        },
        validationSchema: Yup.object({
            merchantId: Yup.string().required("Gerekli"),
            merchantKey: Yup.string().required("Gerekli"),
            merchantSalt: Yup.string().required("Gerekli"),
            companyId: Yup.string().required("Gerekli"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = { ...values, companyCode };
                const res = await upsertVPOSSettings(payload);

                if (res.success || !res.error) { // API yapısına göre düzenle
                    toast.success("Sanal POS ayarları güncellendi");
                } else {
                    toast.error(res.message || "Hata oluştu");
                }
            } catch (error) {
                toast.error("Beklenmeyen hata");
            } finally {
                setLoading(false);
            }
        },
    });

    useEffect(() => {
        if (!companyId) return;
        const loadSettings = async () => {
            try {
                const json = await fetchVPOSSettings(companyId);
                if (json.data) {
                    formik.setValues({
                        merchantId: json.data.merchantId || "",
                        merchantKey: json.data.merchantKey || "",
                        merchantSalt: json.data.merchantSalt || "",
                        testMode: json.data.testMode ?? false,
                        companyId: companyId,
                    });
                }
            } catch (error) {
                console.error(error);
                toast.error("POS ayarları yüklenemedi");
            }
        };
        loadSettings();
    }, [companyId]);

    return { formik, loading };
};